import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutOffice401kHistoryList extends Layout {
    layoutheaderOffice401kHist: LayoutHeader;
    sourceOff401kHist: DataSource;
    tableOffice401kHist: Table;
}
